import { Component, computed, forwardRef, input, model } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { IconService } from "../../services/icon.service";
import { NgClass } from "@angular/common";
import { MatTooltip } from "@angular/material/tooltip";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { asapScheduler } from "rxjs";

@Component({
  selector: "vl-chips-toggle",
  standalone: true,
  imports: [MatIcon, NgClass, MatTooltip],
  templateUrl: "./chips-toggle.component.html",
  styleUrl: "../chips/chips.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ChipsToggleComponent),
      multi: true,
    },
  ],
})
export class ChipsToggleComponent<T = string> {
  value = model<T>();
  elements = input<
    {
      name?: string;
      value: T;
      icon?: string;
      tooltip?: string;
      selectedState?: string;
    }[]
  >([]);
  contentHeight = input(false);
  size = input<"big" | "small">("big");
  cursor = input<"pointer" | "grab" | "default">("pointer");
  testIdPrefix = input<string | null>(null);

  disabled = model(false);

  onChangeFn = (v) => {};
  onTouchFn = (v) => {};

  colorClass = computed(() => {
    return `${this.disabled() ? "chips-disabled cursor-not-allowed" : "cursor-" + this.cursor()} ${this.size() === "big" ? "chips-big" : "chips-small"}`;
  });

  protected readonly IconService = IconService;

  selectElement(element: { name?: string; value: T; icon?: string }) {
    if (this.disabled()) {
      return;
    }
    this.value.set(element.value);
    this.onChangeFn(element.value);
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchFn = fn;
  }

  writeValue(value: any): void {
    asapScheduler.schedule(() => {
      this.value.set(value);
    });
  }

  setDisabledState(value: boolean): void {
    this.disabled.set(value);
  }
}
